import React, { useState, useEffect } from 'react';
import { usePersona } from '@/contexts/PersonaContext';
import { usePermissions } from '@/contexts/PermissionContext';
import { DashboardPage } from '@/components/Pages/DashboardPage';
import { cn } from '@/lib/utils';
import { AccessRestricted } from '@/components/shared/AccessRestricted';

interface PersonaDashboardProps {
  onNavigate?: (path: string) => void;
}

export const PersonaDashboard: React.FC<PersonaDashboardProps> = ({ onNavigate }) => {
  const { currentPersona } = usePersona();
  const { canViewPersonalHomepage } = usePermissions();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayPersona, setDisplayPersona] = useState(currentPersona);

  // Handle smooth transition between personas
  useEffect(() => {
    if (currentPersona !== displayPersona) {
      setIsTransitioning(true);
      
      // Wait for fade out
      const timer = setTimeout(() => {
        setDisplayPersona(currentPersona);
        setIsTransitioning(false);
      }, 150); // Half of the transition duration

      return () => clearTimeout(timer);
    }
  }, [currentPersona, displayPersona]);

  if (!canViewPersonalHomepage()) {
    return (
      <div className="p-6">
        <AccessRestricted message="You don't have permission to view the personal homepage. Contact your administrator to request access." />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Manager/department homepage is hidden for R1 — personal homepage only */}
      <div
        className={cn(
          'transition-opacity duration-300',
          isTransitioning ? 'opacity-0' : 'opacity-100'
        )}
      >
        <DashboardPage onNavigate={onNavigate} />
      </div>
    </div>
  );
};
